import { useNotificationHandler as g } from "./useNotificationHandler.js";
import { _ as h } from "./CardVideo-e725a421.js";
import { resolveComponent as p, resolveDirective as w, openBlock as r, createElementBlock as i, withDirectives as b, withModifiers as x, createTextVNode as y, toDisplayString as _, renderSlot as s, createCommentVNode as l, createElementVNode as u, normalizeClass as c, createBlock as a, withCtx as d } from "vue";
import { _ as S } from "./_plugin-vue_export-helper-dad06003.js";
const k = {
  components: { FormNotification: h },
  props: {
    modelValue: {
      type: [Boolean, Number],
      // true / false | 1 / 0
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    warning: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(e) {
    return g(e);
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.disabled || this.$emit("update:modelValue", e);
      }
    },
    hasTitleSlot() {
      return !!this.$slots.title;
    }
  }
}, v = ["name"], N = {
  key: 0,
  class: "flex-grow text-sm font-medium ct-text-2"
};
function V(e, m, t, B, C, o) {
  const n = p("FormNotification"), f = w("tooltip");
  return r(), i("div", {
    name: t.name,
    "data-scroll": ""
  }, [
    b((r(), i("div", {
      class: "flex items-center justify-between cursor-pointer space-x-1.5",
      onClick: m[0] || (m[0] = x((F) => o.model = !o.model, ["stop"]))
    }, [
      t.title || o.hasTitleSlot ? (r(), i("p", N, [
        y(_(t.title) + " ", 1),
        s(e.$slots, "title")
      ])) : l("", !0),
      u("button", {
        type: "button",
        role: "switch",
        class: c(["relative inline-flex flex-shrink-0 h-5 w-9 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none", {
          "cursor-not-allowed": t.disabled,
          "focus:ct-ring-focus--shadow": !t.disabled,
          "ct-bg-success--solid": o.model,
          "ct-bg-4": !o.model
        }])
      }, [
        u("span", {
          "aria-hidden": "true",
          class: c(["translate-x-0 pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200", { "translate-x-4": o.model, "translate-x-0": !o.model }])
        }, null, 2)
      ], 2)
    ])), [
      [f, { content: t.tooltip, autoHide: !1, html: !0 }]
    ]),
    e.hasHelp ? (r(), a(n, {
      key: 0,
      message: t.help,
      help: "",
      "inner-classes": "mt-1 text-sm ct-text-3"
    }, {
      default: d(() => [
        s(e.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : l("", !0),
    e.hasError ? (r(), a(n, {
      key: 1,
      message: t.error,
      error: "",
      "inner-classes": "mt-1 text-sm ct-text-error"
    }, {
      default: d(() => [
        s(e.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : l("", !0),
    e.hasWarning ? (r(), a(n, {
      key: 2,
      message: t.warning,
      "inner-classes": "mt-2 text-sm ct-text-warning"
    }, {
      default: d(() => [
        s(e.$slots, "warning")
      ]),
      _: 3
    }, 8, ["message"])) : l("", !0)
  ], 8, v);
}
const j = /* @__PURE__ */ S(k, [["render", V]]);
export {
  j as F
};
